// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__Z_DEJ","isHidden":"Notification_isHidden__X4hnq"};